<template>
  <div>

    <div class="row text-left mb-3">

      <!-- <div class="col-sm-12 col-md-4 mb-2 align-items-center justify-content-start">
        <div class="dataTables_filter">
          <label class="d-flex mb-0">
            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
              :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearch">
            <button
              class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
              @click="filterSearch()">
              <i class="fas fa-search"></i>
            </button>
          </label>
        </div>
      </div> -->

      <div class="col-sm-12 col-md-4 mb-2">
        <date-range-picker
          class="w-100"
          ref="picker"
          v-model="selectedDate"
          :opens="'right'"
          :singleDatePicker="false"
          :timePicker="false"
          :showDropdowns="true"
          :ranges="dateRange"
          :always-show-calendars="true"
          :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
          :autoApply="true"
          @update="filterByDate">
        </date-range-picker>
      </div>

      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-file-import"></i>
              </label>
              <multiselect
                :value="selectedType"
                label="type"
                track-by="typeID"
                :options="types"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByType">
                <template slot="option" slot-scope="{ option }">
                  {{ option.type }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-file-import"></i>
              </label>
              <multiselect
                :value="selectedStatus"
                label="status"
                track-by="statusID"
                :options="statuses"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByStatus">
                <template slot="option" slot-scope="{ option }">
                  {{ option.status }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-store"></i>
              </label>
              <multiselect
                :value="selectedOutlet"
                label="text"
                track-by="id"
                :options="outlets"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByOutlet">
                <template slot="option" slot-scope="{ option }">
                  {{ option.text }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-user"></i>
              </label>
              <multiselect
                :value="selectedStaff"
                label="text"
                track-by="staffID"
                :options="staffs"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByStaff">
                <template slot="option" slot-scope="{ option }">
                  {{ option.text }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div class="panel-tag" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>

    <!-- v-if="!isSpinnerShow && totalEntries != 0" -->
    <div class="dataTables_wrapper dt-bootstrap4">

      <!-- <div class="row justify-content-end mt-2">
        <div class="col-auto pt-2">
          <span>
            {{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}
          </span>
        </div>
        <div class="col-auto">
          <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
            @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
        </div>
      </div> -->

      <div class="row" v-if="!isSpinnerShow && totalEntries != 0">
        <div class="col-sm-12 overflow-auto">

          <table class="table table-sm table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
            <thead class="thead-themed">
              <tr>
                <th v-for="tblHeader in fields" :key="'head' + tblHeader.key" :class="tblHeader.key === 'staff' ? 'text-center' : ''">
                  {{ tblHeader.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, j) of items" :key="'row' + j">
                <td class="align-middle">{{ j + 1 }}</td>
                <td class="align-middle" style="min-width: 200px">
                  <div class="row">
                    <div class="col-auto p-0">
                      <b-avatar
                        :src="getStaffImage(item['staffID'])"
                        size="3rem"
                        class=""
                        style="float: left" />
                    </div>
                    <div class="col">
                      <div class="font-weight-bold">{{ getStaffDetail(item['staffID'])['name'] || '' }}</div>
                      <div class="mt-1">
                        <span class="badge badge-pill badge-success"><i class="fas fa-phone"></i></span>
                        {{ getStaffDetail(item['staffID'])['mobile'] || '' }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="align-middle" style="min-width: 160px">
                  <b>Start: </b>{{ getDate(item['startDate']) }}
                  <br>
                  <b>End: </b>{{ getDate(item['stopDate']) }}
                </td>
                <td class="align-middle">{{ getDay(item) }}</td>
                <td class="align-middle"><b>{{ item['type'] }}</b><br></td>
                <td class="align-middle" v-html="getStatus(item)"></td>
                <td class="align-middle">
                  <b-button
                    @click="onEditForm(item)"
                    tabindex="0"
                    variant="outline-primary">
                    <i class="fal fa-pencil fs-xl"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </div>

    <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>

  </div>
</template>
<script>
import moment from "moment";
import DeleteModal from './../../Delete_Modal.vue'
import DateRangePicker from 'vue2-daterange-picker'
import {
  handleSessionExpired,
  setReturnData,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "ConsentListView",
  components: {
    DateRangePicker,
    DeleteModal,
  },
  data() {
    let dateDefaultEnd = moment()
    if (dateDefaultEnd.month() > 10) {
      dateDefaultEnd = dateDefaultEnd.add(1, 'year')
    }

    let statuses = [
      { statusID: '', status: 'All Statuses' },
      { statusID: 'pending', status: 'Pending' },
      { statusID: 'approved', status: 'Approved' },
      { statusID: 'rejected', status: 'Rejected' },
    ]

    return {
      isSpinnerShow: false,
      staffIconDefault: 'https://img.tunai.io/image/s3-5710de08-ba89-4897-9b94-e0af25a45a3f.jpeg',

      dateRange: {
        "Today": [
          moment().toDate(),
          moment().toDate()
        ],
        "Yesterday": [
          moment().subtract(1, "days").toDate(),
          moment().subtract(1, "days").toDate(),
        ],
        "Tomorrow": [
          moment().add(1, "days").toDate(),
          moment().add(1, "days").toDate(),
        ],
        "Last 7 Days": [
          moment().subtract(6, "days").toDate(),
          moment().toDate(),
        ],
        "Last 30 Days": [
          moment().subtract(29, "days").toDate(),
          moment().toDate(),
        ],
        "This Week": [
          moment().startOf("week").toDate(),
          moment().endOf("week").toDate()
        ],
        "This Month": [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate(),
        ],
        "This Year": [
          moment().startOf("year").toDate(),
          moment().endOf("year").toDate()
        ],
        "Last Week": [
          moment().subtract(1, "week").startOf("week").toDate(),
          moment().subtract(1, "week").endOf("week").toDate(),
        ],
        "Last Month": [
          moment().subtract(1, "month").startOf("month").toDate(),
          moment().subtract(1, "month").endOf("month").toDate(),
        ],
        "Last Year": [
          moment().subtract(1, "year").startOf("year").toDate(),
          moment().subtract(1, "year").endOf("year").toDate(),
        ],
        "Next Week": [
          moment().add(1, "week").startOf("week").toDate(),
          moment().add(1, "week").endOf("week").toDate(),
        ],
        "Next Month": [
          moment().add(1, "month").startOf("month").toDate(),
          moment().add(1, "month").endOf("month").toDate(),
        ],
        "Next Year": [
          moment().add(1, "year").startOf("year").toDate(),
          moment().add(1, "year").endOf("year").toDate(),
        ],
      },

      search: '',
      filterObj: {},

      selectedDate: { startDate: moment().startOf('year'), endDate: dateDefaultEnd.endOf('year') },
      outlets: [{ id: '', text: 'All Outlets' }],
      selectedOutlet: {},
      staffs: [],
      selectedStaff: {},
      types: [],
      selectedType: {},
      statuses: statuses,
      selectedStatus: statuses[0],

      staffMap: {},

      items: [],

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,

      exportHeaders: [],
      exportData: [],
      exportFileName: "",
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "staff",
          label: 'Staff Name',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
          sortable: false,
        },
        {
          key: "leave",
          label: 'Leave Date',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: false,
        },
        {
          key: "day",
          label: 'Total Days',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "type",
          label: 'Leave Type',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "status",
          label: 'Status',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "action",
          label: " Action",
          thClass: "thead-themed align-middle",
          tdClass: " align-middle text-center",
        },
      ];
    },
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
  },
  methods: {
    getDate(date) {
      let temp = moment.unix(date)
      return temp.format('ddd, DD/MM/YYYY')
    },
    getStaffImage(staffID) {
      let item = this.staffMap[staffID] || {}

      if (item.icon && item.icon !== this.staffIconDefault) {
        return item.icon
      }

      if (item.image && item.image !== this.staffIconDefault) {
        return item.image
      }

      return this.staffIconDefault
    },
    getStaffDetail(staffID) {
      return this.staffMap[staffID] || {}
    },
    getDay(item) {
      let temp = Math.floor(moment.duration(moment.unix(item['stopDate']).diff(moment.unix(item['startDate']))).asDays()) + 1
      return temp === 1 ? temp + ' day' : temp + ' days'
    },
    getStatus(item) {
      if (item['approvedDate']) {
        return '<span class="badge badge-pill badge-success">Approved</span>'
      }
      if (item['rejectedDate']) {
        return '<span class="badge badge-pill badge-danger">Rejected</span>'
      }
      return '<span class="badge badge-pill badge-warning">Pending</span>'
    },

    setLeaveTypes(types) {
      this.types = [{ typeID: 0, type: 'All Leave Types' }].concat(types)
      this.selectedType = this.types[0]
    },

    filterSearch() {
      this.loadData()
    },
    filterByOutlet(val) {
      this.selectedOutlet = val
      this.loadStaffs()
    },
    filterByStaff(val) {
      this.selectedStaff = val
      this.$emit('onStaffChange', this.selectedStaff)
      this.loadData()
    },
    filterByDate(val) {
      // this.selectedDate = val
      this.loadData()
    },
    filterByType(val) {
      this.selectedType = val
      this.loadData()
    },
    filterByStatus(val) {
      this.selectedStatus = val
      this.loadData()
    },

    async loadStaffs() {
      let url = 'https://staff.tunai.io/business/staff'

      if (this.selectedOutlet && this.selectedOutlet['id'] && this.selectedOutlet['id'] !== 'all') {
        url += '?outletID=' + this.selectedOutlet['id']
      }

      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.staffs = [{ staffID: '', text: 'All Staffs' }]

          for (let staff of response.data.staffs) {
            this.staffMap[staff['staffID']] = staff
            staff['text'] = staff['name'] + ' - ' + staff['mobile']

            if(!staff['enable'] || staff['deleteDate']) {
              continue
            }

            this.staffs.push(staff)
          }

          if (this.selectedStaff && this.selectedStaff['staffID']) {
            let found = this.staffs.find(k => k['staffID'] === this.selectedStaff['staffID'])
            if (!found) {
              this.selectedStaff = null
            }
          }

          this.$emit('onStaffLoad', response.data.staffs)
          this.$emit('onStaffChange', this.selectedStaff)

          if (!this.selectedStaff || !this.selectedStaff['staffID']) {
            this.selectedStaff = this.staffs[0]
          }

          this.loadData()
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    async loadData() {
      let url = 'https://staff.tunai.io/business/break/application'
      url += '?start=' + moment(this.selectedDate.startDate).startOf('day').unix() + '&stop=' + moment(this.selectedDate.endDate).endOf('day').unix()

      if (this.selectedOutlet['id']) {
        url += '&outletID=' + this.selectedOutlet['id']
      }

      if (this.selectedStaff['staffID']) {
        url += '&staffID=' + this.selectedStaff['staffID']
      }

      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.items = response.data.application.sort((a, b) => b['startDate'] - a['startDate'])
          if ((this.selectedStatus && this.selectedStatus.statusID)
            || (this.selectedType && this.selectedType.typeID)) {
            this.items = this.items.filter(temp => {
              if (this.selectedStatus.statusID) {
                if (this.selectedStatus.statusID === 'pending') {
                  if (temp['approvedDate'] || temp['rejectedDate']) {
                    return false
                  }
                } else if (this.selectedStatus.statusID === 'approved') {
                  if (!temp['approvedDate']) {
                    return false
                  }
                } else if (this.selectedStatus.statusID === 'rejected') {
                  if (!temp['rejectedDate']) {
                    return false
                  }
                }
              }

              if (this.selectedType.typeID) {
                if (String(temp['typeID']) !== String(this.selectedType.typeID)) {
                  return false
                }
              }

              return true
            })
          }
          this.totalEntries = response.data.application.length
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },

    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setItems(this.filterObj);
      }
    },
    onEditForm(item) {
      this.$emit('onEditForm', item)
    },
    onDeleteForm(item) {
      this.item = item
      var title = this.$i18n.t('header.delete_file')
      var message = this.$i18n.t('message.confirmation.delete_file')
      this.$refs.deleteModal.showModal(title, message)
    },

    async deleteFile() {
      let $vm = this;
      await $vm
        .$axios({
          method: "post",
          url: 'https://member.tunai.io/business/member/' + this.item.member.memberID + '/item/' + this.item.itemID + '/delete',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.outlets
          this.$refs.deleteModal.toggleModal = false
          this.setItems()
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
  },
  mounted() {
    this.outlets = this.outlets.concat(JSON.parse(this.$store.state.outlets))
    this.selectedOutlet = this.outlets[0]

    this.loadStaffs()
  },
};
</script>

<style scoped>
.hoverColumm {
  min-height: 1px;
}

.hoverColumn:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
</style>